// extracted by mini-css-extract-plugin
export default {"root":"SoldBadge_root__Cl4Ip marketplaceTinyFontStyles"};